import MatchData from '../../data/MatchData'
import ListSelect from '../ListSelect/ListSelect'
import { strToDate } from '../../utils/StringUtils'
import {
  UPDATE_SELECTED_DATE,
  useFilterUpdate
} from '../../contexts/FilterContext'

const DateFilter = ({ selectedDate }) => {
  const filterDispatch = useFilterUpdate()

  const dates = MatchData.map((match) => strToDate(match.match_date))
    .sort((date1, date2) => date1 - date2)
    .map((date) => date.toDateString())
    .map((dateStr) => ({
      value: dateStr,
      displayText: dateStr
    }))

  return (
    <ListSelect
      options={dates}
      label="Date"
      selectedValue={selectedDate}
      onChange={(value) =>
        filterDispatch({ type: UPDATE_SELECTED_DATE, payload: value })
      }
    />
  )
}

export default DateFilter
